module.exports = __webpack_public_path__ + "img/m-home-banner.cce688eb.webp";